import { ScatterplotLayer } from "@deck.gl/layers";

export default class PointLayer {
  constructor(layer_id, data, name, setPopupData) {
    this.layer_id = layer_id;
    this.data = data;
    this.name = name;
    this.setPopupData = setPopupData;
    this.layer = this.generateLayer(this.layer_id, this.data);
  }

  getLayer() {
    return this.layer;
  }

  generateLayer(id, data) {
    return new ScatterplotLayer({
      id: id,
      data: data,
      pickable: true,
      opacity: 0.8,
      stroked: false,
      filled: true,
      radiusScale: 6,
      radiusMinPixels: 5,
      radiusMaxPixels: 10,
      // lineWidthMinPixels: 20,
      getPosition: d => [d.geo[1], d.geo[0]],
      getFillColor: [245, 151, 10],
      getRadius: 50,
      onHover: (info, e) => {
        const { object, x: layerX, y: layerY } = info;
        if (object && object.id) {
          this.setPopupData({
            show: true,
            title: this.name,
            value: `ID: ${object.id}`,
            icon: "bubble_chart",
            metadata: object.meta,
            x: layerX,
            y: layerY,
          });
        } else {
          this.setPopupData({
            show: false,
            x: 0,
            y: 0,
          });
        }
      },
    });
  }
}
